import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {Profile} from "crqlar-react-common/dist/models/profile/profile.model";
import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import AdditionalProperties from "crqlar-react-common/dist/components/AdditionalProperties";
import DocumentField from "./DocumentField";
import Property from "crqlar-react-common/dist/components/Property";
import {Stack} from "@mui/material";

interface Props {
    data: UseEntityData<Profile>
}

const Documents = (props: Props) => {

    const {t} = useTranslation()
    const profile = props.data.item
    const setProfile = props.data.setItem
    const updateField = (field: keyof Profile, value: any) => {
        setProfile({...profile, [field]: value})
    }

    const fieldGroupGap = {xs: 3, sm: 2.5}

    return (
        <AdditionalProperties title={t('Documents')} variant={'outlined'} defaultExpanded={!!profile.documents?.length}>
            <Stack gap={fieldGroupGap}>
            {
                profile.documents?.map((document, index) => {
                    const provider = document.externalInfo?.[0]?.provider
                    const disabled = !!profile.primaryProvider
                    return (
                        <Property
                            orientation={'vertical'}
                            key={index}
                            title={t('Document') + ' ' + (index + 1)}
                            subtitle={provider}
                            sx={{
                                title: {
                                    mt: 2,
                                    fontWeight: 'bold'
                                }
                            }}
                        >
                            <Stack gap={1} width={'100%'}>
                                <DocumentField
                                    document={document}
                                    setDocument={document => {
                                        const documents = [...(profile.documents || [])]
                                        documents[index] = document
                                        updateField('documents', documents)
                                    }}
                                    index={index}
                                    disabled={disabled}
                                />

                                {
                                    !disabled && (
                                        <Stack direction={'row'} justifyContent={'flex-end'}>
                                            <Button
                                                variant={'text'}
                                                size={'small'}
                                                color={'error'}
                                                onClick={() => {
                                                    const documents = [...(profile.documents || [])]
                                                    documents.splice(index, 1)
                                                    updateField('documents', documents)
                                                }}
                                            >
                                                {t('Delete')}
                                            </Button>
                                        </Stack>
                                    )
                                }
                            </Stack>
                        </Property>
                    )
                })
            }


            <Button
                startIcon={<AddIcon/>}
                onClick={() => {
                    const documents = [...(profile.documents || [])]
                    documents.push({})
                    updateField('documents', documents)
                }}
                sx={{
                    alignSelf: 'flex-start'
                }}
            >
                {t('Add document')}
            </Button>

            </Stack>
        </AdditionalProperties>
    )
}

export default Documents;
